import "./App.css";

import React, { useState, useEffect, createContext} from "react";
import { Routes, Route, useNavigate, useLocation} from "react-router-dom";

import { refreshTokens, verifyToken, getStuff } from "./helpers/auth";

import Aid_records from "./components/AidRecords";
import App_user_admin from "./components/App_user_admin";
import Clients from "./components/Clients";
import Overview from "./components/Overview";
import ProjectAdmin from "./components/ProjectAdmin";
import LoginPage from "./components/LoginPage";
import SetNewPasswordPage from "./components/SetNewPasswordPage";
import Layout from "./components/Layout";
import ServerErrorPage from "./components/ServerErrorPage";
import LoadingScreen from "./components/LoadingScreen";
import ProjectPage from "./components/ProjectPage";
import Cookies from "js-cookie";
import ClientPage from "./components/ClientPage";
import AddNewClientPage_p1 from "./components/AddNewClientPage_p1";
import AddNewClientPage_p2 from "./components/AddNewClientPage_p2";
import AddNewClientPage_p3 from "./components/AddNewClientPage_p3";
import MobileAppPage from "./components/MobileAppPage";
import CreateNewProject from "./components/CreateNewProject";
import ActivateAccount from "./components/ActivateAccount";
import ResetPasswordPage from "./components/ResetPasswordPage"
import ResetPasswordConfirmPage from "./components/ResetPasswordConfirmPage"
import AboutPage from "./components/AboutPage"

export const authenticatedContext = createContext();
export const userDataContext = createContext();

const App = () => {
  let navigate = useNavigate();
  const [isCurrentlyLoading, setIsCurrentlyLoading] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);


  const unprotectedRoutes = ["/activate",  "/reset_pass", "/about"]
  const location = useLocation();

  function redirectAfterFirstLoad(path) {
    setIsCurrentlyLoading(false);
    navigate(path);
  }

  function afterSuccessfullAuth() {
    fetchUserData();
    setIsCurrentlyLoading(false);
    setAuthenticated(true);
  }

  function fetchUserData() {
    getStuff("/auth/users/me/").then((res) => {
      if (res.status === 200) {
        setUserData(res.data);
      } else if (res.status === 401) {
        setAuthenticated(false);
      }
    });
  }

  useEffect(() => {
    
    if(unprotectedRoutes.some(str => location.pathname.includes(str))) return;
    if (authenticated && userData ) return;
    setIsCurrentlyLoading(true);
    if (Cookies.get("JWT") == null) {
      redirectAfterFirstLoad("/login");
    } else {
      verifyToken().then((res) => {
        try {
          if (res.status === 401) {
            refreshTokens().then((res) => {
              try {
                if (res.status === 200) {
                  afterSuccessfullAuth();
                } else {
                  redirectAfterFirstLoad("/login");
                }
              } catch (err) {
                redirectAfterFirstLoad("/server_error");
              }
            });
          } else if (res.status === 200) {
            afterSuccessfullAuth();
          }
        } catch (err) {
          redirectAfterFirstLoad("/server_error");
        }
      });
    }
  }, [authenticated]);

  const condition = userData !== null;
  return (
    <>
      {isCurrentlyLoading && <LoadingScreen />}
      <authenticatedContext.Provider
        value={{ authenticated, setAuthenticated }}
      >
        <userDataContext.Provider value={{ userData, setUserData }}>
          <Layout
            content={
              <Routes>
                <Route exact path="/" element={
                  <ProtectedRoute condition={condition}><Overview /></ProtectedRoute>
                } />
                <Route exact path="/clients" element={
                  <ProtectedRoute condition={condition}><Clients /></ProtectedRoute>
                } />
                <Route exact path="/aid_records" element={
                  <ProtectedRoute condition={condition}><Aid_records /></ProtectedRoute>
                } />
                <Route exact path="/app_user_admin" element={
                  <ProtectedRoute condition={condition}><App_user_admin /></ProtectedRoute>
                } />
                <Route exact path="/project_admin" element={
                  <ProtectedRoute condition={condition}><ProjectAdmin /></ProtectedRoute>
                } />
                <Route exact path="/project/:id" element={
                  <ProtectedRoute condition={condition}><ProjectPage /></ProtectedRoute>
                } />
                <Route exact path="/client/:id" element={
                  <ProtectedRoute condition={condition}><ClientPage /></ProtectedRoute>
                } />
                <Route exact path="/add_new_client/p1" element={
                  <ProtectedRoute condition={condition}><AddNewClientPage_p1 /></ProtectedRoute>
                } />
                <Route exact path="/add_new_client/p2/:id" element={
                  <ProtectedRoute condition={condition}><AddNewClientPage_p2 /></ProtectedRoute>
                } />
                <Route exact path="/add_new_client/p3/:id" element={
                  <ProtectedRoute condition={condition}><AddNewClientPage_p3 /></ProtectedRoute>
                } />
                <Route exact path="/project/create" element={
                  <ProtectedRoute condition={condition}><CreateNewProject /></ProtectedRoute>
                } />
                <Route exact path="/login" element={<LoginPage />} />
                <Route exact path="/set_new_password" element={<SetNewPasswordPage />} />
                <Route exact path="/server_error" element={<ServerErrorPage />} />
                <Route exact path="/mobile_app" element={<MobileAppPage />} />
                <Route exact path="/activate/:uid/:token" element={<ActivateAccount/>}/>
                <Route  path="/reset_pass/" element={<ResetPasswordPage/>}/>
                <Route  path="/reset_pass/:new_account" element={<ResetPasswordPage/>}/>
                <Route exact path="/reset_pass/confirm/:uid/:token" element={<ResetPasswordConfirmPage/>}/>
                <Route exact path="/about" element={<AboutPage/>} />
                <Route path="*" element={<ServerErrorPage />} />
              </Routes>
            }
          ></Layout>
        </userDataContext.Provider>
      </authenticatedContext.Provider>
    </>
  );
};

export const ProtectedRoute = ({ children, condition}) => {
  if (condition) {
    return children;
  }
};

export default App;
